import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Projects from './components/Projects';
import Approach from './components/Approach';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProjectModal from './components/ProjectModal';
import Lightbox from './components/Lightbox';
import OpeningReel from './components/OpeningReel';
import { projects } from './data/siteData';

export default function App() {
  const [heroReady, setHeroReady] = useState(false);
  const [introCover, setIntroCover] = useState(true);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const selectedProject = projects.find((p) => p.id === selectedProjectId);

  const scrollToSection = (section) => {
    const el = document.getElementById(section);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const handleExploreClick = () => setSelectedProjectId('enez');
  const handleContactClick = () => scrollToSection('contact');
  const handleProjectClick = (id) => setSelectedProjectId(id);
  const handleModalClose = () => setSelectedProjectId(null);

  const handleImageClick = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
  };

  const handleLightboxClose = () => {
    setLightboxImages([]);
    setLightboxIndex(0);
  };

  const handleNext = () => setLightboxIndex((i) => (i + 1) % lightboxImages.length);
  const handlePrev = () =>
    setLightboxIndex((i) => (i - 1 + lightboxImages.length) % lightboxImages.length);

  return (
    <div className="font-sans bg-nosta-paper text-nosta-ink">
      <AnimatePresence>
        {introCover && (
          <OpeningReel
            caption="Nosta Yapı"
            onReveal={() => setHeroReady(true)}
            onComplete={() => setIntroCover(false)}
          />
        )}
      </AnimatePresence>

      <Header onNavigate={scrollToSection} visible={heroReady} />

      <main>
        <Hero
          introDone={heroReady}
          onExploreClick={handleExploreClick}
          onContactClick={handleContactClick}
          onScrollDown={() => scrollToSection('projects')}
        />
        <Stats />
        <Projects onProjectClick={handleProjectClick} />
        <Approach />
        <About />
        <Contact />
      </main>

      <Footer onNavigate={scrollToSection} />

      <AnimatePresence>
        {selectedProject && (
          <ProjectModal
            project={selectedProject}
            onClose={handleModalClose}
            onImageClick={handleImageClick}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {lightboxImages.length > 0 && (
          <Lightbox
            images={lightboxImages}
            currentIndex={lightboxIndex}
            onClose={handleLightboxClose}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
